export default __webpack_public_path__ + "static/media/React95Video-Numbers.70eb4c83.eot";